export const formatFieldDisplayName = (name) => name.replace(/_/g, " ");

export const getParentsOf = (field) => {
  if (Array.isArray(field?.parent_fields) && field.parent_fields.length > 0) {
    return field.parent_fields;
  }
  if (field?.parent_field) return [field.parent_field];
  return [];
};

export const isMeaningfulValue = (value) => {
  if (value === null || value === undefined) return false;
  if (value === "None" || value === "N/A") return false;
  if (typeof value === "string" && value.trim().length === 0) return false;
  return true;
};

// Boolean extraction fields come back as 1/0, "1"/"0", true/false or plain words
// depending on the connector, so normalise before deciding truthiness.
export const isTruthyFlag = (value) => {
  if (value === true || value === 1 || value === "1") return true;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "true" || normalized === "yes" || normalized === "oui";
  }
  return false;
};

// `hide_when_false` / `hide_when_true` let a company suppress a boolean extraction
// field when its value carries no signal (e.g. "problème détecté" = non).
export const isHiddenByConfig = (field, value) => {
  if (field?.type !== "bool") return false;
  const bool_value = isTruthyFlag(value);
  if (field.hide_when_false && !bool_value) return true;
  if (field.hide_when_true && bool_value) return true;
  return false;
};

export const getLinkedExplanation = (parent_name, to_retrieve_fields, analysis) => {
  const children = (to_retrieve_fields || []).filter((field) =>
    getParentsOf(field).includes(parent_name)
  );
  if (children.length === 0) return null;
  const explanations = children
    .map((child) => analysis?.[child.name])
    .filter(isMeaningfulValue)
    .map((value) => String(value));
  if (explanations.length === 0) return null;
  return explanations.join(" ");
};

// Sider rows are keyed by grading criterion (grade_greeting, grade_identity, …) and
// their human labels live in the `analysis.gradeLabels.*` translations; fall back to
// the raw key when a criterion has no translation yet.
export const getRowLabel = (row, to_retrieve_by_name, t, is_sider) => {
  if (is_sider && row?.key) {
    const translation_key = `analysis.gradeLabels.${row.key}`;
    const translated = t ? t(translation_key) : translation_key;
    return translated === translation_key ? row.key : translated;
  }
  const raw_name = row?.field_name || row?.key || "";
  const matched = to_retrieve_by_name?.[raw_name];
  if (matched?.display_name) return matched.display_name;
  return raw_name.replace(/_/g, " ");
};
